import { render, staticRenderFns } from "./FabBannerBtn.vue?vue&type=template&id=3c45fdb2&scoped=true&"
import script from "./FabBannerBtn.vue?vue&type=script&lang=ts&"
export * from "./FabBannerBtn.vue?vue&type=script&lang=ts&"
import style0 from "./FabBannerBtn.vue?vue&type=style&index=0&id=3c45fdb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45fdb2",
  null
  
)

export default component.exports